import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2580">
      <div className="dark" data-id="element-2581">
        <Hero data-id="element-2582" />
      </div>
      <WhyUs data-id="element-2583" />
      <ByTheNumbers data-id="element-2584" />
      <Services data-id="element-2585" />
      <HowItWorks data-id="element-2586" />
      <FAQ data-id="element-2587" />
      <Reviews data-id="element-2588" />
      <CtaBanner data-id="element-2589" />
    </main>;
}